/**
 * web/src/games/RevealScreen.tsx — the moment the round opens (card eq92fFXqQUuP).
 *
 * Two columns, side by side even at 375px: what they said, what you guessed.
 * Everything here arrives only once the server has revealed — this component
 * has no early access to anything, and it is rendered from a round whose state
 * is 'revealed' or not at all.
 */
import type { GuessMeRound } from '../../../shared/types';

interface RevealScreenProps {
  round: GuessMeRound;
  answererName: string;
  guesserName: string;
}

export function RevealScreen({ round, answererName, guesserName }: RevealScreenProps) {
  const answererIsMe = round.myRole === 'answerer';
  const answer = answererIsMe ? round.myAnswer : round.partnerAnswer;
  const guess = answererIsMe ? round.partnerGuess : round.myGuess;

  return (
    <div className="gm-reveal" id="gm-reveal" data-test="gm-reveal">
      <div className="gm-col" id="gm-col-said">
        <span className="gm-col-label">{answererName} said</span>
        <p className="gm-col-text" id="gm-answer">
          {answer ?? '—'}
        </p>
      </div>
      <div className="gm-col" id="gm-col-guessed">
        <span className="gm-col-label">{guesserName} guessed</span>
        <p className="gm-col-text" id="gm-guess">
          {guess ?? '—'}
        </p>
      </div>
    </div>
  );
}
